import { CachedLogger, dump, getLoggingMode, LogMode } from './cached';
import { StandardLogger } from './standard-logger';
export { isCachingAvailable, isCachingOn, LogMode, toggleCaching, } from './cached';
export { configureLogging } from './standard-logger';
export * from './types';
const current = {
    mode: LogMode.Standard,
    logger: StandardLogger,
};
export function Logger(name) {
    const mode = getLoggingMode();
    if (mode !== current.mode) {
        current.mode = mode;
        current.logger = mode === LogMode.Standard ? StandardLogger : CachedLogger;
    }
    return current.logger(name);
}
export async function getLogsAndClear() {
    return await dump();
}
//# sourceMappingURL=index.js.map